import React from "react";
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading/B';
import AuthIntro from '../AuthIntro';

export default ({children}) => {
  return (
    <div className="auth-content">
      <div className="auth-content__block">
        <AuthIntro />
      </div>
      <div className="auth-content__block">
        {children}
      </div>
    </div>
  )
}
